import {
  DebuggerProvider,
  LoaderProvider,
  OttOverlayProvider,
  OverlayProvider,
  PageViewProvider,
} from '../../contexts'
import { ICategoryTreeItem, Ileafs, IProgramData } from '../../types'
import React from 'react'
import { IOttPageMeta } from '../../utils'
import { PageViewInDayProvider } from '../../contexts/hooks/usePageViewInDay'
import { OttPlayerProvider } from '../contexts/providers/OttPlayerProvider'
import { UserActivityProvider } from '../../contexts/UserActivityContext'

type OttProps = {
  children: React.ReactNode
  theTree: ICategoryTreeItem[]
  leafs: Ileafs[]
  program: IProgramData | null
  assetMeta: IOttPageMeta
  logo?: string
  page_type?: string
}

export const OttProviders = ({
  children,
  theTree,
  leafs,
  program,
  assetMeta,
  logo,
  page_type,
}: OttProps) => {
  return (
    <UserActivityProvider>
      <DebuggerProvider>
        <PageViewProvider>
          <PageViewInDayProvider>
            <LoaderProvider>
              <OttOverlayProvider
                theTree={theTree}
                leafs={leafs}
                program={program}
                assetMeta={assetMeta}
                logo={logo}
                page_type={page_type}
              >
                <OverlayProvider>
                  <OttPlayerProvider>{children}</OttPlayerProvider>
                </OverlayProvider>
              </OttOverlayProvider>
            </LoaderProvider>
          </PageViewInDayProvider>
        </PageViewProvider>
      </DebuggerProvider>
    </UserActivityProvider>
  )
}
